export default __webpack_public_path__ + "static/media/HiveDesk_Logo_blue.e825f6a6.svg";